import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../../shared/utility";
import _ from 'underscore';
import { IAnalyze } from "../../../interface/iAnalyse";
import { IString } from "../../../interface/base";

const initialState: IAnalyze = {
  loading: true,
  fetchingScores: false,
  initLiveDataLoaded: false,
  identifiers: [],
  attendedIdentifiers: [],
  tags: [],
  currentSession: {},
  all: [],
  realTimeGraphType: 1, // 0 - overall, 1 - realtime
  markers: [],
  markersLoaded: false,
  analyseStart: null,
  analyseEnd: null,
  clips: [],
  clipLoaded: false,
  initialClipLoaded: false,
  immersion_overall: null,
  safety_overall: null,
  cliped: null,
  analyzeClipData: [],
  excludedParticipants: [],
  excludedParticipantsReason:[],
  liveFirstLoadTime: 0,
  xlsxData: null,
  stimulus: null,
  realTimeImmersionScores: {},
  hiddenParticipants: [],
  overviewToKeymoment: null,
  fullLoadedAnalysis: false,
  isLoadedIdentifiers: false,
  fingerpulseIdentifiers: [],
  fingerpulse: false,
  settings: {
    pencil: false,
    clip: false,
    graphZoom: 7,
    addNoteX: -1,
    addNoteY: -1,
    xScroll: 0,
    videoPopIn: 0,
    videoPlayed: 0,
    videoStopped: true,
    videoPlaying: false,
    videoSkip: false,
    clickedPillsTime: new Date().getTime(),
    mqttStatus: null,
    mqttBackendCalcTime: null,
    liveDisabledIdentifers: false,
    videoRemoved: false
  }
};

const getTagAndIdentifiers = (list: any[]) => {
  const response: any[] = [];
  let allTags: any[] = [];
  list.map((item: IString) => allTags = [...allTags, ...Object.values(item['tag_cloud'])]);
  let tag_names: any[] = [];
  allTags.map((item: IString) => tag_names = [...tag_names, ...Object.values(item)]);
  const tags = tag_names.filter((item, index) => tag_names.indexOf(item) === index);
  tags.forEach((tag) => {
    response.push(pairTagAndIdentifiers(list, tag));
  });
  return response;
};

const pairTagAndIdentifiers = (list: any[], tagName: string) => {
  const identifiers: any[] = [];
  list.forEach((listItem) => {
    const tagNames: any[] = [];
    for (const i in listItem['tag_cloud']) {
      tagNames.push(listItem['tag_cloud'][i]['tag_name']);
    }
    if (tagNames.indexOf(tagName) !== -1) {
      identifiers.push(listItem['identifier']);
    }
  });
  return {
    tagName,
    identifiers
  };
};
const getTowerTagAndIdentifiers = (list: any[]) => {
	const response: any[] = [];
	let allTags: any[] = [];
	list.forEach((item: IString) => {
		if (!!item['tower_tag_cloud']) {
			allTags = [...allTags, item['tower_tag_cloud']]
		}
	});
	let tag_names: any[] = [];
	allTags.forEach((item: IString) => tag_names = [...tag_names, ...Object.values(item)]);
	const tagss = tag_names.filter((item, index) => tag_names.indexOf(item) === index);
	tagss.forEach((tag) => {
		response.push(pairTowerTagAndIdentifiers(list, tag));
	});
	return response;
};

const pairTowerTagAndIdentifiers = (list: any[], tagName: string) => {
	const identifiers: any[] = [];
	list.forEach((listItem) => {
		const tagNames: any[] = [];
		const towerTagList: any = listItem['tower_tag_cloud'] ? Object.values(listItem['tower_tag_cloud']) : []
		for (const i in towerTagList) {
			tagNames.push(towerTagList[i]);
		}
		if (tagNames.indexOf(tagName) !== -1) {
			identifiers.push(listItem['identifier']);
		}
	});
	return {
		tagName,
		identifiers
	};
};
const reducer = (state = { ...initialState }, action: any) => {
  switch (action.type) {

    case actionTypes.SET_ANALYSIS_LOADING:
      return updateObject(state, {
        loading: action.payload
      });

    case actionTypes.SET_FETCHING_SCORES:
      return updateObject(state, {
        fetchingScores: action.payload
      });

    case actionTypes.INIT_ANALYSIS_DATA:
      return updateObject(state, {
        loading: action.payload ? action.payload : true,
        fetchingScores: false,
        initLiveDataLoaded: false,
        identifiers: [],
        attendedIdentifiers: [],
        currentSession: {},
        all: [],
        realTimeGraphType: 1, // 0 - overall, 1 - realtime
        markers: [],
        markersLoaded: false,
        analyseStart: null,
        analyseEnd: null,
        clips: [],
        clipLoaded: false,
        initialClipLoaded: false,
        immersion_overall: null,
        safety_overall: null,
        cliped: null,
        excludedParticipants: [],
        excludedParticipantsReason: [],
        completed: false,
        xlsxData: null,
        tags: [],
        stimulus: null,
        realTimeImmersionScores: {},
        hiddenParticipants: [],
        overviewToKeymoment: null,
        fullLoadedAnalysis: false,
        isLoadedIdentifiers: false,
        fingerpulseIdentifiers: [],
        fingerpulse: false,
        settings: {
          pencil: false,
          clip: false,
          graphZoom: 7,
          addNoteX: -1,
          addNoteY: -1,
          xScroll: 0,
          videoPopIn: 0,
          videoPlayed: 0,
          videoStopped: true,
          videoPlaying: false,
          videoSkip: false,
          clickedPillsTime: new Date().getTime(),
          mqttStatus: null,
          mqttBackendCalcTime: null,
          liveDisabledIdentifers: false,
          videoRemoved: false
        }
      });

    case actionTypes.GET_REALTIME_IMMERSION_SCORES:
      const currentRealTimeImmersionScores = { ...state.realTimeImmersionScores };
      const key = action.payload['name'];
      const color_indicator = action.payload['data'] ? action.payload['data']['color_indicator'] : 'Red';
      const immersion_index = action.payload['data'] ? action.payload['data']['immersion_index'] : 0;
      const context_indicator = action.payload['data'] ? action.payload['data']['context_indicator'] : '';
      const newItem: any = {};
      newItem[key] = {
        color_indicator,
        immersion_index,
        context_indicator
      };
      return updateObject(state, {
        realTimeImmersionScores: { ...currentRealTimeImmersionScores, ...newItem }
      });

    case actionTypes.SAVE_CURRENT_SESSION:
      return updateObject(state, {
        currentSession: action.payload,
      });

    case actionTypes.UPDATED_TO_LIVE:
      return updateObject(state, {
        currentSession: action.payload,
      });

    case actionTypes.UPDATE_LOADED_TIME:
      return updateObject(state, {
        loadedTimeLength: action.payload
      });

    case actionTypes.CHANGE_REALTIME_GRAPH_TYPE:
      return updateObject(state, {
        realTimeGraphType: action.payload
      });

    case actionTypes.GET_IDENTIFIERS:
      const validList = action.payload.filter((item: IString) => !!item['identifier'] && !!item['tag_cloud']);
      const reasonList = action.payload.filter((item: IString) => !!item['identifier'] && !!item['exclude_reason']);
	    const validtowerList = action.payload.filter((item: IString) => !!item['identifier'] && !!item['tower_tag_cloud']);
      // const identifiers = action.payload.filter((item: IString) => !!item['identifier'] && (action.isAttendCalculate ? item['attended'] : true)).map((item: IString) => item.identifier);
      const identifiers = action.payload.filter((item: IString) => !!item['identifier']).map((item: IString) => item.identifier);
      const attendedIdentifiers = action.payload.filter((item: IString) => !!item['identifier'] && item.attended).map((item: IString) => item.identifier);
      const fingerpulseIdentifiers = action.payload.filter((item: IString) => !!item['identifier'] && item.attended && item.fingerpulse).map((item: IString) => item.identifier);
      return updateObject(state, {
        attendedIdentifiers,
        identifiers,
        isLoadedIdentifiers: true,
        tags: getTagAndIdentifiers(validList),
		    towertags:getTowerTagAndIdentifiers(validtowerList),
        loading: false,
        excludeReasons: reasonList,
        fingerpulseIdentifiers
      });

    case actionTypes.GET_ALL_GRAPHIC_DATA:
      const oldAll = [...state.all];
      const duplicated = oldAll.findIndex((item: any) => item.activeParticipant === action.payload.activeParticipant);

      if (duplicated === -1) {
        if (action.payload['activeParticipant'] === 'All') {
          oldAll.unshift(action.payload)
        } else {
          if (action.payload['isTag']) {
            const existAllItem = oldAll.find((item: any) => item['activeParticipant'] === 'All');
            if (existAllItem) {
              oldAll.splice(1, 0, action.payload);
            } else {
              oldAll.unshift(action.payload);
            }
          } else {
            oldAll.push(action.payload);
          }
        }
      } else {
        if (action.payload.status) {
          oldAll[duplicated] = { ...action.payload }
        } else {
          oldAll[duplicated].immersion.data = _.uniq([
            ...(oldAll[duplicated].immersion.data ? oldAll[duplicated].immersion.data : []),
            ...action.payload.immersion.data
          ], function (x) { return x.time_stamp })

          oldAll[duplicated].overall_immersion = action.payload.overall_immersion
          oldAll[duplicated].immersion.overall_context_indicator = action.payload.immersion.overall_context_indicator;

          if (action.payload.isLiveAsyncAll) {
            oldAll[duplicated].immersion = action.payload.immersion
          }
          if (action.payload.isLiveAsyncAll) {
            oldAll[duplicated].pills = action.payload.pills
          }
        }
      }

      let excludLoading = false;
      if (action.payload.status && action.payload.pills.length === 0 && action.payload.immersion.overall_index > 0) {
        excludLoading = true;
      }

      return updateObject(state, {
        loading: excludLoading,
        all: [...oldAll],
        fullLoadedAnalysis: true
      });

    case actionTypes.REMOVE_GRAPH_DATA:
      const oldAll2 = [...state.all];
      const duplicatedIndex = state.all.findIndex((item: any) => item.activeParticipant === action.payload.activeParticipant);
      if (duplicatedIndex !== -1) {
        oldAll2.splice(duplicatedIndex, 1);
      }
      const existAllItemIndex = state.hiddenParticipants.findIndex((item: any) => item === action.payload.activeParticipant);
      const oldP = [...state.hiddenParticipants]
      if (existAllItemIndex !== -1) {
        oldP.splice(duplicatedIndex, 1);
      } else {
        oldP.push(action.payload.activeParticipant);
      }
      return updateObject(state, {
        all: oldAll2,
        hiddenParticipants: [...oldP]
      });

    case actionTypes.GET_FETCH_SESSION_MARKERS:
      return updateObject(state, {
        markers: action.payload,
        markersLoaded: true
      });

    case actionTypes.UPDATE_MARKER_DATA:
      return {
        ...state,
        markers: state.markers.map(
          (content,) => content.marker_id === action.payload.id ? { ...content, marker_title: action.payload.text }
            : content
        )
      }

    case actionTypes.GET_SESSION_RANGE:
      const start = action.payload.start;
      const end = action.payload.end;

      return updateObject(state, {
        analyseStart: start,
        analyseEnd: end
      });

    case actionTypes.GET_SEGMENT_AS_CLIP:
      const newClips = action.payload.map((item: any) => {
        return {
          title: item.title,
          start_clip: item.start_clip,
          end_clip: item.end_clip,
          clip_id: item.clip_id
        }
      });
      return updateObject(state, {
        clips: [...newClips],
        clipLoaded: true,
        initialClipLoaded: true
      });

    case actionTypes.PUT_SEGMENT_AS_CLIP:
      return updateObject(state, {
        clipLoaded: false,
      });

    case actionTypes.CLIP_SUCCESS:
      return updateObject(state, {
        clipLoaded: false,
      });

    case actionTypes.GET_SAFETY_OVERALL:
      return updateObject(state, {
        safety_overall: action.payload,
      });

    case actionTypes.GET_IMMERSION_OVERALL:
      return updateObject(state, {
        immersion_overall: action.payload,
      });

    case actionTypes.REMOVE_CLIPED_DATA:
      localStorage.removeItem("cliped")
      return updateObject(state, {
        cliped: null,
      });

    case actionTypes.UPDATE_CLIPED_DATA:
      localStorage.setItem("cliped", JSON.stringify(action.payload))
      return updateObject(state, {
        cliped: action.payload,
      });
    
    case actionTypes.UPDATE_ANALYSE_CLIP_DATA:
        return updateObject(state, {
          analyzeClipData: action.payload,
        });

    case actionTypes.UPDATE_SESSIOIN_RANGE_BYCLIP:
      return updateObject(state, {
        loading: true,
        all: [],
        analyseStart: action.payload.start,
        analyseEnd: action.payload.end,
      });

    case actionTypes.UPDATE_SESSIOIN_RANGE_LIVE:
      return updateObject(state, {
        analyseStart: action.payload.start,
        analyseEnd: action.payload.end,
        liveFirstLoadTime: state.liveFirstLoadTime === 0 ? action.payload.end : state.liveFirstLoadTime
      });

    case actionTypes.GET_EXCLUDED_PARTICIPANTS:
      return updateObject(state, {
        excludedParticipants: action.payload.map((item: any) => item.identifier),
        excludedParticipantsReason: action.payload
      });

    case actionTypes.REMOVE_ALL_PARTICIPANT:
      const all2 = [...state.all];
      const newAll2 = all2.filter((item: any) => item.activeParticipant !== 'All');
      return updateObject(state, {
        all: [...newAll2]
      });

    case actionTypes.REMOVE_ALL_GRAPH:
      return updateObject(state, {
        all: [],
        immersion_overall: {},
        safety_overall: {},
      });

    case actionTypes.UPDATE_OVERAL_IMMMERSION:
      return updateObject(state, {
        immersion_overall: action.payload.immersion,
        safety_overall: action.payload.safety,
      });

    case actionTypes.GET_XLSX_SUCCESS:
      return updateObject(state, {
        xlsxData: action.payload
      });

    case actionTypes.REMOVE_PARTICIPANT_FROM_ALL:
      const excludedParticipants = action.payload;
      const currentAll = [...state.all];
      return updateObject(state, {
        all: currentAll.filter((item: any) => !excludedParticipants.includes(item['activeParticipant']))
      });

    case actionTypes.GET_STIMULUS_ANALYSIS:
      return updateObject(state, {
        stimulus: action.payload
      });

    case actionTypes.ADD_OVERVIEW_TO_ANALYSIS_KEY_MOMENT:
      return updateObject(state, {
        overviewToKeymoment: action.payload
      });

    case actionTypes.ADD_VIDEO_LENGTH:
      return updateObject(state, {
        stimulus: { ...state.stimulus, stimulus_video_length: action.payload }
      });

    case actionTypes.UPDATE_SETTINGS:
      return updateObject(state, {
        settings: {
          ...state.settings, [action.payload.name]: action.payload.value
        }
      });

    case actionTypes.UPDATE_FULL_LOAD_ANALYSIS:
      return updateObject(state, {
        fullLoadedAnalysis: action.payload
      });

    case actionTypes.OPTIMIZE_LIVE_GRAPH:
      const all3 = [...state.all];
      const newAll3 = all3.filter((item: any) => item.activeParticipant === 'All');
      return updateObject(state, {
        all: [...newAll3]
      });

    case actionTypes.UPDATE_ALL_PARTICIPANT_PILLS:
      const all4 = [...state.all];
      all4[0].pills = action.payload
      return updateObject(state, {
        all: [...all4]
      });

    case actionTypes.SET_FINGER_PULSE:
      return updateObject(state, {
        fingerpulse: action.payload
      });
      
    default:
      return state;
  }
};

export default reducer;